var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"top"}},[_c('div',{staticClass:"bar",class:{'is-inline': _vm.inline, 'with-scroll': _vm.withScroll, 'has-scrolled': _vm.hasScrolled, 'is-community': _vm.$route.meta.isCommunity}},[_c('div',{staticClass:"inner"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }